export const LICENSE_PRODUCTS = {
  CBAM: "cbam",
  PPWR: "ppwr",
  CBAM_MRV: "cbam_mrv",
};
